import styles from "./Iframe.module.scss";

export type IframeProps = {
  title: string;
} & Omit<React.IframeHTMLAttributes<HTMLIFrameElement>, "title">;

export const Iframe = ({
  className,
  allowFullScreen = true,
  title,
  sandbox = "allow-scripts allow-forms allow-same-origin",
  ...restProps
}: IframeProps) => {
  return (
    <div className={`${styles.iframe} ${className ?? ""}`}>
      <iframe allowFullScreen={allowFullScreen} sandbox={sandbox} title={title} {...restProps} />
    </div>
  );
};
